import { styled } from '@linaria/react';
import { RefObject } from 'react';

import { uiToken } from '~/shared/constants/uiToken';

export const Root = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const IconWrapper = styled.div`
  position: absolute;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 8px;
  height: 100%;
  z-index: 1;
`;

export const PrefixIconWrapper = styled(IconWrapper)<{
  children?: React.ReactNode;
  innerIndent?: number;
  ref?: RefObject<HTMLDivElement | null>;
}>`
  left: 0;
  margin-left: ${(props) => props.innerIndent || 0}px;
`;

export const PostfixIconWrapper = styled(IconWrapper)<{
  children?: React.ReactNode;
  innerIndent?: number;
  ref?: RefObject<HTMLDivElement | null>;
}>`
  right: 0;
  margin-right: ${(props) => props.innerIndent || 0}px;
`;

export const StyledBasicInput = styled.input<{ isInvalid?: boolean }>`
  position: relative;
  width: 100%;
  color: ${uiToken.color.text.primary};
  outline: none;
  font-size: 15px;
  font-weight: 500;
  line-height: 160%;
  background-color: transparent;
  font-family: Inter, sans-serif;

  &:disabled {
    cursor: not-allowed;
    color: ${uiToken.color.text.disabled};
  }

  &::placeholder {
    color: ${(props) =>
        props.isInvalid
          ? uiToken.color.system.error
          : uiToken.color.text.secondary}
      /* stylelint-disable */ !important;
    font-family: Inter, sans-serif;
    transition: color 0.2s ease-in-out;
  }

  &:disabled::placeholder {
    color: ${uiToken.color.text.disabled};
  }

  &:focus::placeholder {
    color: ${(props) =>
      props.isInvalid
        ? uiToken.color.system.error
        : uiToken.color.text.secondary};
  }
`;
